module.exports = __webpack_public_path__ + "static/img/fatih-ozdemir-3TYYiHRTKcg.3ffbdcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/fatih-ozdemir-3TYYiHRTKcg.jpg
// module id = 2hMK
// module chunks = 1